<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <div v-if="created" class="alert alert-success" role="status">{{ created.name }} {{$t('notifications.created')}}.</div>
          <div v-if="updated" class="alert alert-success" role="status">{{ updated.name }} {{$t('notifications.updated')}}.</div>
          <div v-if="isLoading || deleteLoading" class="alert alert-info" role="status">{{$t('notifications.loading')}}...</div>
          <div v-if="error" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}
          </div>
          <div v-if="deleteError" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ deleteError }}
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <router-link v-if="item" :to="{ name: 'EXSBItemsCategoryList' }" class="btn btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
<!--          <button class="btn btn-danger" @click="del">{{ $t('buttons.delete') }}</button>-->
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="card-body">
              <b-row>
                <b-col>
                  <EXSBItemsCategoryForm
                          v-if="item"
                          :handle-submit="onSendForm"
                          :handle-update-field="updateField"
                          :values="item"
                          :errors="violations"
                          :initial-values="retrieved" />
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXSBItemsCategoryForm from './Form.vue'
import { checkPagePermission } from '@/utils/checkRoles.js'

export default {
  components: {
    EXSBItemsCategoryForm
  },

  data () {
    return {
      item: {}
    }
  },

  beforeCreate () {
    checkPagePermission('warehouses', 'EXSBItemCategoryUpdate')
  },

  computed: {
    ...mapGetters({
      isLoading: 'exsbitemscategory/update/isLoading',
      error: 'exsbitemscategory/update/error',
      deleteError: 'exsbitemscategory/del/error',
      deleteLoading: 'exsbitemscategory/del/isLoading',
      created: 'exsbitemscategory/create/created',
      deleted: 'exsbitemscategory/del/deleted',
      retrieved: 'exsbitemscategory/update/retrieved',
      updated: 'exsbitemscategory/update/updated',
      violations: 'exsbitemscategory/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXSBItemsCategoryList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'exsbitemscategory/create/reset',
      deleteItem: 'exsbitemscategory/del/del',
      delReset: 'exsbitemscategory/del/reset',
      retrieve: 'exsbitemscategory/update/retrieve',
      updateReset: 'exsbitemscategory/update/reset',
      update: 'exsbitemscategory/update/update',
      updateRetrieved: 'exsbitemscategory/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this exsbitemscategory ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
